// План создания ленивой загрузки
// 1. Оболочке изображения или скрываемого нами блока присваиваем класс ._wrap-to-animation с фоном колеса загрузки.
// 1.1 Ниже изображения создаём на том же уровне импорт фона.Фоном может служить блок с CSS анимацией под названием include../ lazy - load / lazy - load
// Или присваиваем стиль background: url('../images/loading.gif') center / 50px no-repeat;
// 2. Добавляем изображениям аттрибут data-src со значением места нахождения картинки.
// 3. добавляем изображению путь к картинке 1х1px PNG формата, с прозрачностью, у src аттрибута
// 4. В оболочку карты добавляем атрибут data-map со значением ссылки на карту (значение "src" iframe карты). Идобавляем технический клас для оболочки. Блок самой карты можно удалить.
// 5. В конструкции picture/source/ Указываем аттрибут data-srcset c указанием места нахождения изображения. Так же аттрибуту srcset указываем значение - путь к картинке 1х1px PNG формата, с прозрачностью
// 6. ПРИМЕР img(src="imagesNative/1x1clear.png", data-src="images/grid/cover-image-300x200.webp", alt="alt")
// 7. Видео инструкция https://www.youtube.com/watch?v=IdUbsiQUxa4 и https://www.youtube.com/watch?v=-2kzokozC7E


// Lazy Load function

let lazyImages = document.querySelectorAll('img[data-src],source[data-srcset]');
// Определяем высоту окна просмотра
let windowHeight = document.documentElement.clientHeight;
// let loadMapBlock = document.querySelector('.техКлассКарты');
let loadMoreBlock = document.querySelector('._load-more');

let lazyImagesPositions = [];
if (lazyImages.length > 0) {
    lazyImages.forEach(img => {
        if (img.dataset.src || img.dataset.srcset) {
            // Вставляем положение каждого изображения в позиции страницы сайта
            lazyImagesPositions.push(img.getBoundingClientRect().top + scrollY);
            lazyScrollCheck();
        }
    });
}

// Слушаем скролл
window.addEventListener('scroll', lazyScroll);

function lazyScroll() {
    // Поиск по изображениям которые не были показаны
    if (document.querySelectorAll('img[data-src],source[data-srcset]').length > 0) {
        lazyScrollCheck();
    }
}


function lazyScrollCheck() {
    let imgIndex = lazyImagesPositions.findIndex(
        // Ищем индекс элемента, по позиции его положения на странице: количество прокрученных пикселей > позиция элемента - высота окна просмотра браузера
        item => scrollY > item - windowHeight
    );
    // Если, что-то найдено, то делаем проверку и вставляем в изначальные аттрибуты src данные местоположения картинки и удаляем новые аттрибуты data-src
    if (imgIndex >= 0) {
        if (lazyImages[imgIndex].dataset.src) {
            lazyImages[imgIndex].src = lazyImages[imgIndex].dataset.src;
            lazyImages[imgIndex].removeAttribute('data-src');
            lazyImages[imgIndex].parentElement.classList.remove('_wrap-to-animation')
        } else if (lazyImages[imgIndex].dataset.srcset) {
            lazyImages[imgIndex].srcset = lazyImages[imgIndex].dataset.srcset;
            lazyImages[imgIndex].removeAttribute('data-srcset');
            lazyImages[imgIndex].parentElement.classList.remove('_wrap-to-animation')
        }
        delete lazyImagesPositions[imgIndex];
    }
}

function loadMore() {
    const loadMoreBlockPos = loadMoreBlock.getBoundingClientRect().top + scrollY;
    const loadMoreBlockHeight = loadMoreBlock.offsetHeight;

    if (scrollY > (loadMoreBlockPos + loadMoreBlockHeight) - windowHeight) {
        getContent();
    }
}


// Загрузка блоков. !Требуется знание работы с сервером AJAX
// async function getContent() {
//     if (!document.querySelector('._loading-icon')) {
//         loadMoreBlock.insertAdjacentHTML(
//             'beforeend',
//             `<div class="_loading-icon"></div>`
//         );
//     }
//     loadMoreBlock.classList.add('_loading');
// }


// Загружаем карту
// function getMap() {
//     const loadMapBlockPos = loadMapBlock.getBoundingClientRect().top + scrollY;
//     if (scrollY > loadMapBlockPos - windowHeight) {
//         const loadMapUrl = loadMapBlock.dataset.map;
//         if (loadMapUrl) {
//             loadMapBlock.insertAdjacentHTML(
//                 "beforeend",
//                 `<ifame src="${loadMapUrl}" style ="border:0;" allowfullScreeen="" loading="lazy"></ifame>`
//             );
//             loadMapBlock.classList.add('_loaded');
//         }
//     }
// }